import React, {memo} from 'react';
import linerShading from '~images/liner_shading.png';

interface EnvelopeLinerProps {
  imageUrl?: string | null;
}

export const EnvelopeLiner: React.FC<EnvelopeLinerProps> = memo(({imageUrl}) => {
  if (!imageUrl) return null;

  return (
    <>
      <img
        alt="envelope-liner-shadow"
        src={linerShading}
        className="envelope_image__wrapper__liner__shadow"
      />
      <img src={imageUrl} className="envelope_image__wrapper__liner" alt="Envelope Liner" />
    </>
  );
});
